export default (store) => {
    let stateToSet;

    if (store.state.company) {
        stateToSet = _.get(store.state, `company.filter_presets.${store.state.listview}`, null);
    } else {
        stateToSet = _.get(store.ng.injector.get('Users').state, `company.filter_presets.${store.state.listview}`, null);
    }

    if (
        store.state.persist
        && localStorage.getItem(store.state.listview)
    ) {
        stateToSet = JSON.parse(localStorage.getItem(store.state.listview));
    }

    if (stateToSet) {
        store.resetState();
        store.commit('mergeState', stateToSet)
    }

    return store;
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/load-state.js